import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeLeft32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconEdgeLeft32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20.5 25.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M16.75 24a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-19a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M10.5 25.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M11.75 5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m14 14a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-1.25-8.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M25.75 14a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M20.5 6.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M7 9.5a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeLeft32);
